import { useMemo, useState } from "react"
import { isSafari } from "../../../util/browser"
import useEase from "../hooks/useEase"

type Vector = { x: number; y: number }

function CircleTransition({ position, color, children }) {
  const [animationState, setAnimationState] = useState<"RUNNING" | "FINISHED">(
    "RUNNING"
  )

  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  )
  const vh = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  )

  const x = { x: 0, y: 0 },
    xx = { x: vw, y: 0 },
    y = { x: 0, y: vh },
    yy = { x: vw, y: vh }

  const sub = (a: Vector, b: Vector) => ({
    x: a.x - b.x,
    y: a.y - b.y
  })

  const magnitude = (vec: Vector) => Math.sqrt(vec.x * vec.x + vec.y * vec.y)

  const radiusToAnim = useMemo(() => {
    const one = magnitude(sub(position, x))
    const two = magnitude(sub(position, xx))
    const three = magnitude(sub(position, y))
    const four = magnitude(sub(position, yy))

    const addRadius = isSafari()

    return Math.max(one, two, three, four) + (addRadius ? 50 : 0)
  }, [position])


  const { animationProgress } = useEase({
    start: 0,
    end: radiusToAnim,
    ease: "easeOutExpo",
    speed: 1,
    onEnd: () => {
      setAnimationState("FINISHED")
    }
  })

  return (
    <>
      <svg
        viewBox={`0 0 ${window.innerWidth} ${window.innerHeight}`}
        xmlns="http://www.w3.org/2000/svg"
        width={window.innerWidth}
        height={window.innerHeight}
        overflow="visible"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100svh"
        }}
      >
        <circle
          cx={`${position.x}`}
          cy={`${position.y}`}
          r={animationProgress.ease}
          fill={color}
          stroke="transparent"
          style={{
            position: "absolute"
          }}
        />
      </svg>
      {children(animationState)}
    </>
  )
}

export default CircleTransition
